export const HISTORY_STATUS = {
  rejected: -1,
  waiting: 0,
  process: 1,
  sending: 2,
  completed: 3,
};

export const USER_TYPE = [
  { role: 99, name: "Super Admin" },
  { role: 50, name: "Admin" },
  { role: 1, name: "SPM" },
];

export const STATUS_USER = {
  active: {
    name: "active",
    code: 0,
  },
  suspend: {
    name: "suspend",
    code: -1,
  },
};

export const ACTION_URL = {
  openModal: "open_modal",
};
